import { render, staticRenderFns } from "./SupplierQualityAnalysisSystem.vue?vue&type=template&id=66b4fc5d&scoped=true"
import script from "./SupplierQualityAnalysisSystem.vue?vue&type=script&lang=js"
export * from "./SupplierQualityAnalysisSystem.vue?vue&type=script&lang=js"
import style0 from "./SupplierQualityAnalysisSystem.vue?vue&type=style&index=0&id=66b4fc5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b4fc5d",
  null
  
)

export default component.exports